import React from 'react';
import t from '~t';
import { Modal, ModalContent as Content, Button, Layout, Title } from '~ui';

export default function DialogConfirmView({
  id,
  message,
  description,
  ok,
  cancel,
  variant,
  sendResult,
}) {
  return (
    <Modal
      className='w-[8rem]'
      important={true}
      onClose={() => sendResult(id, false)}
    >
      <Content>
        <Layout>
          <Title>
            {variant == 'warning' ? '⚠' : ''} {message}
          </Title>
          <div className='text-foreground'>{description}</div>

          <Button
            data-block
            autoFocus
            onClick={() => sendResult(id, true)}
          >
            {ok || 'OK'}
          </Button>

          <Button
            data-block
            variant='outline'
            onClick={() => sendResult(id, false)}
          >
            {cancel || t.s('cancel')}
          </Button>
        </Layout>
      </Content>
    </Modal>
  );
}
